import React from 'react'
import iqd_rounding from '../../utils/iqd_rounding';
import numberbeautify from '../../utils/numberbeautify';
import moment from 'moment/moment';

const Company_loan_back_ledger_table = ({loan_back}) => {
    return (
        <div>
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی دراوە</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کۆمپانیا
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بەرواری گەڕاندنەوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی دراوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی داشکاندن
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                تێبینی
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {loan_back?.map((lis)=>(
                        <tr key={lis.loan_out_id} className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.company_name}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                <p className="text-slate-800 whitespace-no-wrap" dir="ltr">
                                    {moment(lis.loan_out_date).format("YYYY-MM-DD")}
                                </p>
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(iqd_rounding(lis.loan_out_amount))} IQD
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(iqd_rounding(lis.loan_out_discount))} IQD
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis?.loan_out_note}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
    )
}

export default Company_loan_back_ledger_table